<template>
    <div class="form-group d-flex">
        <div>
            <label>
                <localized-text :localizedKey="label" :text="label"></localized-text>
            </label>
            <div>
                <template v-if="canUpload">
                    <file-input v-model="fileToUpload"></file-input>
                </template>
                <template name="cant" v-else>
                    <localized-text localizedKey="Salva prima di caricare allegati" text="Salva prima di caricare allegati"></localized-text>
                </template>
            </div>
            <div class="mt-2">
                <button class="btn btn-primary" @click="uploadFile" :disabled="!fileToUpload">
                    <localized-text localizedKey="Carica" text="Carica"></localized-text>
                </button>
            </div>
        </div>
        <div>
            <slot name="preview">
                <img style="max-height: 120px;" :src="localValue.publicUrl" v-if="localValue && localValue.publicUrl" />
            </slot>
        </div>
    </div>
</template>

<script lang="ts">
import WithModel from '@/mixins/withModel';
import { mixins, Options, Vue } from 'vue-class-component';
import * as OM from '@/model';
import { Prop } from 'vue-property-decorator';
import {UploadServices} from '@/services/UploadServices';

@Options({})
export default class attachmentUploader extends mixins(WithModel) {

    @Prop() label: string;
    @Prop() canUpload: boolean;

    fileToUpload: File = null;

    declare modelValue: OM.Attachment;

    uploadFile(){
        UploadServices.UploadFile({
            entityIdentifier: "",
            file: this.fileToUpload
        })
        .then(x => {
            this.emitModel(x);
        })
    }

}

</script>